// project imports
import { withAlpha } from 'utils/colorUtils';

// ==============================|| OVERRIDES - PAGINATION / ALERT / SWITCH / DIVIDER / SKELETON / TOOLTIP ||============================== //

export default function Misc(theme) {
  const v = theme.vars.palette;
  const soft = (c) => ({
    backgroundColor: v[c].lighter,
    color: v[c].darker,
    border: `1px solid ${withAlpha(v[c].main, 0.25)}`,
    '& .MuiAlert-icon': { color: v[c].main }
  });
  return {
    MuiTablePagination: {
      styleOverrides: {
        root: { borderTop: `1px solid ${v.grey[200]}`, color: v.grey[600] },
        toolbar: { minHeight: 52 },
        selectLabel: { fontSize: '0.8125rem', margin: 0 },
        displayedRows: { fontSize: '0.8125rem', margin: 0 }
      }
    },
    MuiPaginationItem: { styleOverrides: { root: { borderRadius: 8 } } },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 10, fontSize: '0.8125rem', alignItems: 'center' },
        standardSuccess: soft('success'),
        standardError: soft('error'),
        standardWarning: soft('warning'),
        standardInfo: soft('info')
      }
    },
    MuiSwitch: {
      styleOverrides: {
        root: { width: 40, height: 22, padding: 0 },
        switchBase: {
          padding: 2,
          '&.Mui-checked': { transform: 'translateX(18px)', color: '#fff', '& + .MuiSwitch-track': { opacity: 1 } }
        },
        thumb: { width: 18, height: 18, boxShadow: 'none' },
        track: { borderRadius: 11, backgroundColor: v.grey[300], opacity: 1 }
      }
    },
    MuiDivider: { styleOverrides: { root: { borderColor: v.grey[200] } } },
    MuiSkeleton: { styleOverrides: { root: { backgroundColor: v.grey[100] } } },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { backgroundColor: v.grey[900], fontSize: '0.75rem', borderRadius: 6, padding: '6px 10px' },
        arrow: { color: v.grey[900] }
      }
    },
    MuiFormControlLabel: { styleOverrides: { label: { fontSize: '0.875rem' } } },
    MuiAutocomplete: {
      styleOverrides: { paper: { borderRadius: 10, border: `1px solid ${v.grey[200]}`, boxShadow: '0 8px 24px rgba(16,24,40,0.12)' } }
    }
  };
}
